import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const paymentApi = createApi({
    reducerPath: 'paymentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_baseURL+"/payment",
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.userToken;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        createPaymentSession: builder.mutation({
        query: (data) => ({
            url: '/create-session',
            method: 'POST',
            body: data,
        }),
        }),
        paymentCallback: builder.mutation({
        query: (data) => ({
            url: '/callback',
            method: 'POST',
            body: data,
        }),
        }),
    }),
});

export const { useCreatePaymentSessionMutation, usePaymentCallbackMutation } = paymentApi;